"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cvDegreeOf = cvDegreeOf;
const imports_1 = require("./imports");
// ADR 0062 / docs/PLAN-icp-main-ranking.md §2.9 (OQ2 a) — the degree fact when the candidate's record has none.
/**
 * Degree-shaped words only, strongest level first. A CV is free text, so a bare "master" ("Scrum Master", "master data") or
 * "graduate" ("Graduate Trainee") must not count: the import's own word list reads a short answer in an Education column and
 * can be loose; a whole CV cannot. Words are matched on the import's normal form ("M.Sc." is "msc", "Master's" is "master s").
 */
const CV_DEGREE_WORDS = [
    ['doctorate', ['phd', 'doctorate', 'dphil']],
    [
        'masters',
        ['masters degree', 'master s degree', 'master degree', 'masters in', 'master s in', 'masters of', 'master of', 'msc', 'mba', 'ma', 'mphil', 'mcom', 'mss', 'meng', 'mtech'],
    ],
    ['bachelors', ['bachelors', 'bachelor s', 'bachelor', 'bsc', 'bba', 'ba', 'bcom', 'bss', 'beng', 'btech', 'llb', 'mbbs', 'honours', 'hons']],
    ['diploma', ['diploma']],
    ['hsc', ['hsc', 'alim', 'a level', 'a levels']],
    ['ssc', ['ssc', 'dakhil', 'o level', 'o levels']],
];
/**
 * The highest education level whose degree words appear whole in the CV text, or null when none does: "B.Sc. in CSE … HSC … SSC"
 * is bachelors; "MBA" is masters and never "BA", because words match whole. "Pursuing an MBA" or "MBA (ongoing)" counts as masters
 * too (owner OQ2 a: the CV's words are all the code can see, and a person on the way to a degree is far likelier to be a fit than a
 * no-degree). Run when a CV's text is read and stored on `documents.degree_level`.
 */
function cvDegreeOf(text) {
    const padded = ` ${(0, imports_1.normaliseHeader)(text)} `;
    if (padded.trim() === '')
        return null;
    return CV_DEGREE_WORDS.find(([, words]) => words.some((word) => padded.includes(` ${word} `)))?.[0] ?? null;
}
//# sourceMappingURL=cv-degree.js.map